import { render } from "./SubsidiesNewYearDialog.vue?vue&type=template&id=95bf35f6&scoped=true"
import script from "./SubsidiesNewYearDialog.vue?vue&type=script&lang=js"
export * from "./SubsidiesNewYearDialog.vue?vue&type=script&lang=js"

import "./SubsidiesNewYearDialog.vue?vue&type=style&index=0&id=95bf35f6&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-95bf35f6"]])

export default __exports__